import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ListType } from '@hyper-inferno/survey-elements-core';

@Component({
  selector: 'lib-add-list-dialog',
  imports: [MatDialogModule, ReactiveFormsModule, MatButtonModule],
  templateUrl: './add-list-dialog.html',
  styleUrl: './add-list-dialog.scss',
})
export class AddListDialog implements OnInit {
  ngOnInit(): void {
    if (this.data.listName) {
      this.form.patchValue({ name: this.data.listName });
    }
  }
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<AddListDialog>);
  public data = inject(MAT_DIALOG_DATA) as {
    surveyId: number | undefined;
    es_entityName: string;
    elementId: string;
    listName: string;
  };

  ListType = ListType;

  form = this.fb.group({
    name: this.fb.control('', Validators.required),
    list_type: this.fb.control<ListType>(
      ListType.NORMAL_LIST,
      Validators.required,
    ),
  });

  confirmAddList() {
    if (this.form.invalid) {
      return;
    }

    this.dialogRef.close({
      success: true,
      data: {
        name: this.form.value.name,
        list_type: this.form.value.list_type,
        survey_id: this.data.surveyId,
        es_entityName: this.data.es_entityName,
        elementId: this.data.elementId,
      },
    });
  }

  cancel() {
    this.dialogRef.close();
  }
}
